import { z } from 'zod'

export const settingsSubject = z.tuple([
  z.literal('access'),
  z.literal('Settings'),
])

export type SettingsSubject = z.infer<typeof settingsSubject>
